const ambient = require('./ambient.js')
const owise1 = require('./owise1.js')

module.exports = {
  ambient : ambient,
  owise1 : owise1
}
